<template>
  <modal :is-open="youReceivedShinyCharmModal && !claimShinyCharmModalisOpen"
         :closeable="false">

    <h3>Congratulations!</h3>

    <br>

    <div style="text-align:center;">
      You received a shiny charm!

      <div v-if="shinyCharmAmount <= 1"><br>You unlocked a new upgrade for your Pokedex!</div>
    </div>
    <div style="position:relative;">


      <ItemEntryButton
          :id="1"
          :name="''"
          :sprite_name="'shiny_charm'"
          :amount="0"
          :category="'collectable'"
          :tmType='null'
      />
    </div>

    <template #footer>
      <button type="button" class="btn btn-secondary" @click="youReceivedShinyCharmModal=false;">
        {{ translation.general.close }}
      </button>
    </template>
  </modal>

  <modal :is-open="claimShinyCharmModalisOpen"
         :closeable="false">

    <h4>Congratulations on completing the spawnable dex!</h4>

    <span>You can claim your Shiny Charm now!</span>
    <br>
    <br>
    After claiming your shiny charm you have the option to reset your catchable dex
    progress and start over to earn additional shiny charms.
    <br>
    <br>
    <div>
      Shiny Chance:
    </div>
    <div>0x Charms: 1/1250</div>
    <div>1x Charms: 1/625</div>
    <div>2x Charms: 1/415</div>
    <div>3x Charms: 1/312</div>

    <template #footer>
      <button type="button" class="btn btn-secondary" @click="claimShinyCharmModalisOpen=false;">
        {{ translation.general.cancel }}
      </button>

      <button type="button" class="btn btn-primary" @click="claimShinyCharm();">
        Claim
      </button>
    </template>
  </modal>

  <modal :is-open="resetDexModalIsOpen"
         :closeable="false">

    <h3 style="color: red;">This action will reset your catchable dex progress and can't be undone!</h3>


    <template #footer>
      <button type="button" class="btn btn-secondary" @click="resetDexModalIsOpen=false;">
        {{ translation.general.cancel }}
      </button>

      <button type="button" class="btn btn-primary" @click="resetDex();">
        Reset
      </button>
    </template>
  </modal>


  <div>
    <PokemonDexInfoModal
        :isOpen="showPokedexEntryText"
        :pokemonId="currentPokemonId"
        @update:isOpen="showPokedexEntryText = $event"
    ></PokemonDexInfoModal>

    <div class="container">
      <h5 class="pokemon-list__title" style="margin-top: 15px">
        Total: {{ progressNumber }} / {{ totalPkm }} ({{
          ((progressNumber / totalPkm) * 100).toFixed(2)
        }}%)
      </h5>

      <h5 class="pokemon-list__title" style="margin-top: 10px; font-size: 3vh;">
        Spawnable: {{ catchableProgressNumber }} / {{ catchablePkm }} ({{
          ((catchableProgressNumber / catchablePkm) * 100).toFixed(2)
        }}%)
      </h5>


      <div style="display: flex;">
        <div style="width: 40%;">
          <input
              type="text"
              v-model="input_pokemon"
              placeholder="Search..."
              style="width: 100%;"
              v-on:input="
            input_pokemon = $event.target.value;
            filter(input_pokemon);"
          />
        </div>

        <div style="width: 20%;text-align: center;margin-top:3px;">
          {{ filteredCaughtAmount }} / {{ allPokemon.length }}
        </div>


        <div v-if="shinyCharmAmount > 0" style="width: 40%;margin:auto;">
          <button v-if="!showAltDex" @click="toggleAltDex();filter(input_pokemon);"
                  class="toggle-missing-button">Alt Dex
          </button>
          <button v-else @click="toggleAltDex();filter(input_pokemon);" class="toggle-missing-button">Main Dex
          </button>
        </div>


      </div>

      <div style="display: flex;flex-wrap: wrap;">
        <div style="width:50%;display: flex">


          Spawnable:
          <div style="width:3%;"></div>
          <input type="checkbox" checked="checked"
                 @click="showSpawnable=!showSpawnable;filter(input_pokemon);">
        </div>
        <div style="width:50%;display: flex">


          Starters:
          <div style="width:3%;"></div>
          <input type="checkbox" checked="checked"
                 @click="showStarters=!showStarters;filter(input_pokemon);">
        </div>
        <div style="width:50%;display: flex;justify-content: right;">


          Legendaries:
          <div style="width:3%;"></div>
          <input type="checkbox" checked="checked"
                 @click="showLegendaries=!showLegendaries;filter(input_pokemon);">
        </div>
        <div style="width:50%;display: flex;justify-content: right;">


          Show Missing:
          <div style="width:3%;"></div>
          <input type="checkbox"
                 @click="filterByCaught();filter(input_pokemon)">
        </div>
      </div>

      <div style="display: flex;">
        <button class="toggle-missing-button" :disabled="catchableProgressNumber < catchablePkm || shinyCharmClaimed"
                @click="claimShinyCharmModalisOpen=true">Claim Charm
        </button>

        <button class="toggle-missing-button" :disabled="catchableProgressNumber < catchablePkm || !shinyCharmClaimed"
                @click="resetDexModalIsOpen=true">Reset Dex
        </button>
      </div>

      <div class="row p-2" v-if="allPokemon.length > 0">
        <div class="col-3 pokemon-list__entry" v-for="pokemon in allPokemon" v-bind:key="pokemon.id">
          <div v-if="pokemon.c">
            <div
                class="pokemon-entry-button pokemon-entry-button__sprite"
                @click="
                currentPokemonId = pokemon.id;
                showPokedexEntryText = true;
              "
                :style="{
                backgroundImage:
                  'url(' +
                  (imageUri +
                    'static/pokedex/png-sprites/pokemon/' +
                    pokemon.id +
                    '.png') +
                  ')',
              }"
                style="opacity: 1"
            ></div>
            <div v-if="starterListPokemon.includes(String(pokemon.id))" style="position:absolute;font-size: 2vh;">
              🎊
            </div>
            <div v-else-if="legendaryListPokemon.includes(String(pokemon.id))"
                 style="position:absolute;font-size: 2vh;">
              🔒
            </div>
            <div v-else-if="!spawnablePokemon.includes(String(pokemon.id))" style="position:absolute;font-size: 2vh;">
            </div>
          </div>

          <div v-else>
            <div
                class="pokemon-entry-button__sprite"
                :style="{
                backgroundImage:
                  'url(' +
                  (imageUri +
                    'static/pokedex/png-sprites/pokemon/' +
                    pokemon.id +
                    '.png') +
                  ')',
              }"
                style="
                opacity: 0.2;
                filter: grayscale(100%);
                -webkit-filter: grayscale(100%);
              "
            ></div>
          </div>

          <div>


            <div v-if="starterListPokemon.includes(String(pokemon.id))" style="position:absolute;font-size: 2vh;">
              🎊
            </div>
            <div v-else-if="legendaryListPokemon.includes(String(pokemon.id))"
                 style="position:absolute;font-size: 2vh;">
              🔒
            </div>
            <div v-else-if="!spawnablePokemon.includes(String(pokemon.id))" style="position:absolute;font-size: 2vh;">
            </div>

            <br/>
            <br/>

            <div style="text-align: center">
              {{ pokemon.name }}
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PokemonDexInfoModal from "../../components/PokemonDexInfoModal/PokemonDexInfoModal.vue";
import axios from "axios";
import {translation} from "@/utils/translations";
import {backendUri, imageUri} from "@/utils/settings";
import {ref} from "@vue/reactivity";
import {onMounted} from "@vue/runtime-core";
import {
  isLoading,
  startLoadingProcess,
  stopLoadingProcess,
} from "@/components/LoadingOverlay/loadingOverlayControl";
import {handleUnknownError, sort_by} from "@/utils/utilities";
import {isBlocked} from "../../components/ButtonControl/ButtonControl";
import {ALL_TYPES} from "../../utils/pokemonConstants";
import Modal from "@/components/Modal/Modal";
import ItemEntryButton from "../../components/ItemEntryButton/ItemEntryButton.vue";
import {tierAssociations, typeAssociations} from "../../utils/globals";


export default {
  name: "PokemonList",
  components: {
    PokemonDexInfoModal,
    Modal,
    ItemEntryButton
  },
  data() {
    return {
      input_pokemon: ""
    }
  },
  setup() {
    const pokedexEntryIds = ref([]);
    const progressNumber = ref(0);
    const catchableProgressNumber = ref(0);
    const pokedexEntryIdsToShow = ref([]);
    const currentPokemonId = ref(0)
    const filteredCaughtAmount = ref(0)
    const allPokemonNames = ref([]);
    const allPokemon = ref([]);
    const allPokemonUnfiltered = ref([]);
    const attrFilter = ref("id");
    const sortOrder = ref(true);
    const onlyShowMissingEntries = ref(true);
    const showLegendaries = ref(true);
    const showAltDex = ref(false);
    const showStarters = ref(true);
    const showSpawnable = ref(true);
    const showPokedexEntryText = ref(false);
    const shinyCharmClaimed = ref(false);
    const resetDexModalIsOpen = ref(false);
    const claimShinyCharmModalisOpen = ref(false);
    const shinyCharmAmount = ref(0);
    const youReceivedShinyCharmModal = ref(false);
    const spawnablePokemon = ['10', '100', '101', '102', '103', '104', '105', '106', '107', '108', '109', '11', '110', '111', '112', '113', '114', '115', '116', '117', '118', '119', '12', '120', '121', '122', '123', '124', '125', '126', '127', '128', '129', '13', '130', '131', '132', '133', '134', '135', '136', '137', '138', '139', '14', '140', '141', '142', '143', '147', '148', '149', '15', '16', '161', '162', '163', '164', '165', '166', '167', '168', '169', '17', '170', '171', '172', '173', '174', '175', '176', '177', '178', '179', '18', '180', '181', '182', '183', '184', '185', '186', '187', '188', '189', '19', '190', '191', '192', '193', '194', '195', '196', '197', '198', '199', '20', '200', '201', '202', '203', '204', '205', '206', '207', '208', '209', '21', '210', '211', '212', '213', '214', '215', '216', '217', '218', '219', '22', '220', '221', '222', '223', '224', '225', '226', '227', '228', '229', '23', '230', '231', '232', '233', '234', '235', '236', '237', '238', '239', '24', '240', '241', '242', '246', '247', '248', '25', '26', '261', '262', '263', '264', '265', '266', '267', '268', '269', '27', '270', '271', '272', '273', '274', '275', '276', '277', '278', '279', '28', '280', '281', '282', '283', '284', '285', '286', '287', '288', '289', '29', '290', '291', '292', '293', '294', '295', '296', '297', '298', '299', '30', '300', '301', '302', '303', '304', '305', '306', '307', '308', '309', '31', '310', '311', '312', '313', '314', '315', '316', '317', '318', '319', '32', '320', '321', '322', '323', '324', '325', '326', '327', '328', '329', '33', '330', '331', '332', '333', '334', '335', '336', '337', '338', '339', '34', '340', '341', '342', '343', '344', '345', '346', '347', '348', '349', '35', '350', '351', '352', '353', '354', '355', '356', '357', '358', '359', '36', '360', '361', '362', '363', '364', '365', '366', '367', '368', '369', '37', '370', '371', '372', '373', '374', '375', '376', '38', '39', '396', '397', '398', '399', '40', '400', '401', '402', '403', '404', '405', '406', '407', '408', '409', '41', '410', '411', '412', '413', '414', '415', '416', '417', '418', '419', '42', '420', '421', '422', '423', '424', '425', '426', '427', '428', '429', '43', '430', '431', '432', '433', '434', '435', '436', '437', '438', '439', '44', '440', '441', '442', '443', '444', '445', '446', '447', '448', '449', '45', '450', '451', '452', '453', '454', '455', '456', '457', '458', '459', '46', '460', '461', '462', '463', '464', '465', '466', '467', '468', '469', '47', '470', '471', '472', '473', '474', '475', '476', '477', '478', '479', '48', '49', '50', '504', '505', '506', '507', '508', '509', '51', '510', '511', '512', '513', '514', '515', '516', '517', '518', '519', '52', '520', '521', '522', '523', '524', '525', '526', '527', '528', '529', '53', '530', '531', '532', '533', '534', '535', '536', '537', '538', '539', '54', '540', '541', '542', '543', '544', '545', '546', '547', '548', '549', '55', '550', '551', '552', '553', '554', '555', '556', '557', '558', '559', '56', '560', '561', '562', '563', '564', '565', '566', '567', '568', '569', '57', '570', '571', '572', '573', '574', '575', '576', '577', '578', '579', '58', '580', '581', '582', '583', '584', '585', '586', '587', '588', '589', '59', '590', '591', '592', '593', '594', '595', '596', '597', '598', '599', '60', '600', '601', '602', '603', '604', '605', '606', '607', '608', '609', '61', '610', '611', '612', '613', '614', '615', '616', '617', '618', '619', '62', '620', '621', '622', '623', '624', '625', '626', '627', '628', '629', '63', '630', '631', '632', '633', '634', '635', '636', '637', '64', '65', '659', '66', '660', '661', '662', '663', '664', '665', '666', '667', '668', '669', '67', '670', '671', '672', '673', '674', '675', '676', '677', '678', '679', '68', '680', '681', '682', '683', '684', '685', '686', '687', '688', '689', '69', '690', '691', '692', '693', '694', '695', '696', '697', '698', '699', '70', '700', '701', '702', '703', '704', '705', '706', '707', '708', '709', '71', '710', '711', '712', '713', '714', '715', '72', '73', '731', '732', '733', '734', '735', '736', '737', '738', '739', '74', '740', '741', '742', '743', '744', '745', '746', '747', '748', '749', '75', '750', '751', '752', '753', '754', '755', '756', '757', '758', '759', '76', '760', '761', '762', '763', '764', '765', '766', '767', '768', '769', '77', '770', '771', '774', '775', '776', '777', '778', '779', '78', '780', '781', '782', '783', '784', '79', '80', '81', '819', '82', '820', '821', '822', '823', '824', '825', '826', '827', '828', '829', '83', '830', '831', '832', '833', '834', '835', '836', '837', '838', '839', '84', '840', '841', '842', '843', '844', '845', '846', '847', '848', '849', '85', '850', '851', '852', '853', '854', '855', '856', '857', '858', '859', '86', '860', '861', '862', '863', '864', '865', '866', '867', '868', '869', '87', '870', '871', '872', '873', '874', '875', '876', '877', '878', '879', '88', '880', '881', '882', '883', '884', '885', '886', '887', '89', '90', '91', '92', '93', '94', '95', '96', '97', '98', '99', '899', '900', '901', '902', '903', '904'];
    const starterListPokemon = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '152', '153', '154', '155', '156', '157', '158', '159', '160', '252', '253', '254', '255', '256', '257', '258', '259', '260', '387', '388', '389', '390', '391', '392', '393', '394', '395', '495', '496', '497', '498', '499', '500', '501', '502', '503', '650', '651', '652', '653', '654', '655', '656', '657', '658', '722', '723', '724', '725', '726', '727', '728', '729', '730', '810', '811', '812', '813', '814', '815', '816', '817', '818'];
    const legendaryListPokemon = ['144', '145', '146', '150', '151', '243', '244', '245', '249', '250', '251', '377', '378', '379', '380', '381', '382', '383', '384', '385', '386', '480', '481', '482', '483', '484', '485', '486', '487', '488', '489', '490', '491', '492', '493', '494', '638', '639', '640', '641', '642', '643', '644', '645', '646', '647', '648', '649', '716', '717', '718', '719', '720', '721', '772', '773', '785', '786', '787', '788', '789', '790', '791', '792', '793', '794', '795', '796', '797', '798', '799', '800', '801', '802', '803', '804', '805', '806', '807', '808', '809', '888', '889', '890', '891', '892', '893', '894', '895', '896', '897', '898', '10139', '10006', '10007', '10018', '10019', '10020', '10021', '10022', '10023', '10024', '10033', '10034', '10035', '10036', '10040', '10041', '10043', '10044', '10047', '10056', '10057', '10074', '10075', '10086', '10265', '10266', '10267', '10268', '10269', '10270', '10271', '10272', '10273', '10274', '10275', '10276', '10277', '10278', '10279', '10280', '10281', '10282', '10293', '10294', '10297', '10298', '10299', '10323', '10354', '10355', '10356', '10357', '10371', '10374', '10390', '10398', '10402', '10403', '10415', '10419', '10420', '10421', '10472', '10473', '10474', '10475', '10476', '10477', '10478', '10479', '10480', '10481', '10482', '10483', '10484', '10485', '10486', '10487', '10488', '10538', '10546', '10548', '10549', '10550', '10551', '10554', '10555', '100001', '100004'];

    const totalPkm = ref(0);
    const catchablePkm = ref(0);
    const refreshView = async () => {
      startLoadingProcess();
      await axios
          .get(backendUri + "api/game/ext/trainer/pokedex/")
          .then((resp) => {
            totalPkm.value = resp.data.totalPkm;
            catchablePkm.value = resp.data.catchablePkm;
            shinyCharmAmount.value = resp.data.shinyCharmAmount;

            progressNumber.value = resp.data.progress;
            catchableProgressNumber.value = resp.data.catchableProgress;

            allPokemon.value = [];
            for (let pokemon in resp.data.dex) {
              let pkm = resp.data.dex[pokemon];
              allPokemon.value.push(pkm);
            }
            allPokemonUnfiltered.value = allPokemon.value;
            allPokemonNames.value = resp.data.names;

            shinyCharmClaimed.value = resp.data.shinyCharmClaimed;
            filter('');
          })
          .catch((error) => {
            handleUnknownError(error);
          });

      stopLoadingProcess();
    };

    const claimShinyCharm = async () => {
      startLoadingProcess();
      await axios
          .post(backendUri + "api/game/ext/trainer/claim-charm/")
          .then(() => {
            youReceivedShinyCharmModal.value = true;
            claimShinyCharmModalisOpen.value = false;
            refreshView();
          })
          .catch((error) => {
            handleUnknownError(error);
          });

      stopLoadingProcess();
    };

    const resetDex = async () => {
      startLoadingProcess();
      await axios
          .post(backendUri + "api/game/ext/trainer/reset-dex/")
          .then(() => {
            resetDexModalIsOpen.value = false;
            refreshView();
          })
          .catch((error) => {
            handleUnknownError(error);
          });

      stopLoadingProcess();
    };

    onMounted(() => {
      refreshView();
    });

    const toggleAltDex = async () => {
      showAltDex.value = !showAltDex.value;
    };

    const filterByCaught = async () => {
      filteredCaughtAmount.value = 0;
      onlyShowMissingEntries.value = !onlyShowMissingEntries.value
    };

    const filterByName = async (name) => {
      var tmp = [];
      for (var i = 0; i < allPokemonUnfiltered.value.length; i++) {
        var pkm_name = allPokemonUnfiltered.value[i].name.toLowerCase();

        if (pkm_name.includes(name.toLowerCase())) {
          tmp.push(allPokemonUnfiltered.value[i]);
        }
      }
      allPokemon.value = tmp;
    };

    const dynamicSort = async () => {
      allPokemon.value.sort(sort_by("pokedexId", sortOrder.value));
    };

    const changeAscDesc = async () => {
      sortOrder.value = !sortOrder.value;
      allPokemon.value.sort(sort_by("pokedexId", sortOrder.value));
    };

    const sleep = (ms) => {
      return new Promise((resolve) => setTimeout(resolve, ms));
    };

    const debounce = (callback, wait) => {
      let timeout;

      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          callback.apply(this, args);
        }, wait);
      };
    };

    const filter = debounce(async (text) => {
      startLoadingProcess();


      await sleep(450);
      if (text[0] === "!") {
        await advancedFilter(text);
      } else {
        await filterByName(text);
      }

      // todo: move everything in a function except for that part here
      filteredCaughtAmount.value = 0;
      let tmp = []
      for (var i = 0; i < allPokemon.value.length; i++) {

        let pokedex_id = allPokemon.value[i].id
        if (!showAltDex.value) {
          if (pokedex_id > 10000) {
            continue
          }
        } else {
          if (pokedex_id < 10000) {
            continue
          }
        }

        pokedex_id = pokedex_id.toString();
        if (!showStarters.value) {
          if ((starterListPokemon.includes(pokedex_id))) {
            continue
          }
        }

        if (!showLegendaries.value) {
          if ((legendaryListPokemon.includes(pokedex_id))) {
            continue
          }
        }

        if (!showSpawnable.value) {
          if (spawnablePokemon.includes(pokedex_id)) {
            continue
          }
        }

        if (onlyShowMissingEntries.value === false) {
          if (allPokemon.value[i].c === false) {
            tmp.push(allPokemon.value[i]);
            if (allPokemon.value[i].c) {
              filteredCaughtAmount.value += 1
            }
          }
        } else {
          tmp.push(allPokemon.value[i]);
          if (allPokemon.value[i].c) {
            filteredCaughtAmount.value += 1
          }
        }
      }

      allPokemon.value = tmp;

      stopLoadingProcess();
    }, 500);

    const advancedFilter = async (text) => {
      text = text.toLowerCase();
      let filtered = [];

      let terms;
      if (text.startsWith("!g")) {
        terms = text.match(/(!\w\s(\w?\+?\s?\w+))/g);
      } else if (text.startsWith("!tier")) {
        terms = text.match(/(!\w+\s(\w?\+?\s?\w+))/g);
      } else {
        terms = text.match(/(!\w\s(\w+\s?\+?\s?\w+))/g);
      }

      if (terms === -1 || terms === null) return;

      for (const element of terms) {
        try {
          if (element.includes("!t")) {
            let pokemons =
                filtered.length > 0 ? filtered : allPokemonUnfiltered.value;
            const parameters = element.match(/!t(.*)/)[1].trim();

            if (parameters === null) continue;

            const result = await filterByType(parameters, pokemons);

            filtered = result;
          }

          if (element.includes("!tier")) {
            let pokemons =
                filtered.length > 0 ? filtered : allPokemonUnfiltered.value;
            const parameters = element.match(/!tier(.*)/)[1].trim();

            if (parameters === null) continue;

            const result = await filterByTier(parameters, pokemons);

            filtered = result;
          }

          if (element.includes("!b")) {
            let pokemons =
                filtered.length > 0 ? filtered : allPokemonUnfiltered.value;

            const parameters = element.match(/!b(.*)/)[1].trim();

            if (parameters === null) continue;

            const result = filterByBaseStats(parameters, pokemons);

            filtered = result;
          }

          if (element.includes("!g")) {
            let pokemons = filtered.length > 0 ? filtered : allPokemonUnfiltered.value;

            const parameters = element.match(/!g(.*)/)[1].trim();
            console.log(parameters);
            if (parameters === null) continue;

            const result = filterByGeneration(parameters, pokemons);

            filtered = result;
          }

        } catch {
          // console.warn("User is typing...");
        }
      }
      allPokemon.value = filtered;
    };

    function getPokemonsFromGeneration(generation) {
      generation = parseInt(generation)
      if (generation === 1) {
        return [1, 151]
      } else if (generation === 2) {
        return [152, 251]
      } else if (generation === 3) {
        return [252, 386]
      } else if (generation === 4) {
        return [387, 493]
      } else if (generation === 5) {
        return [495, 649]
      } else if (generation === 6) {
        return [650, 721]
      } else if (generation === 7) {
        return [722, 809]
      } else if (generation === 8) {
        return [810, 898]
      }
    }

    const filterByTier = (parameters, pokemons) => {
      let allowed_ids = tierAssociations.value[parameters.toUpperCase()];
      return pokemons.filter((x) =>
          allowed_ids.includes(x.pokedexId)
      );
    };

    const filterByGeneration = (parameters, pokemons) => {
      let resp = getPokemonsFromGeneration(parameters)
      let min = resp[0]
      let max = resp[1]
      return pokemons.filter((x) => x.order <= Number(max) && x.order >= Number(min));
    };

    const filterByBaseStats = (parameters, pokemons) => {
      return pokemons.filter((x) => x.baseStats <= Number(parameters));
    };

    const filterByType = async (terms, pokemons) => {
      let types = terms.split("+").map((x) => x.trim().toLowerCase());

      if (types.length > 2) {
        return [];
      }

      for (const type of types) {
        if (!ALL_TYPES.includes(type)) {
          return [];
        }
      }

      let filtered = [];

      const typeIds = {};

      // get data for each type
      for (let type of types) {
        typeIds[type] = typeAssociations.value[type];

      }

      let intersectionIds = [];
      if (Object.keys(typeIds).length === 2) {
        const typeOne = new Set(Object.values(typeIds)[0]);
        const typeTwo = new Set(Object.values(typeIds)[1]);

        intersectionIds = Array.from(
            new Set([...typeOne].filter((x) => typeTwo.has(x)))
        );
      } else {
        intersectionIds = Object.values(typeIds)[0];
      }

      for (const poke of pokemons) {
        const pokeapiDexId = poke.pokedexId;
        if (intersectionIds.includes(pokeapiDexId)) {
          filtered.push(poke);
        }
      }

      filtered = [...new Set(filtered)];

      return filtered;
    };


    return {
      translation,
      refreshView,
      allPokemon,
      attrFilter,
      sortOrder,
      changeAscDesc,
      filterByName,
      dynamicSort,
      isBlocked,
      isLoading,
      pokedexEntryIds,
      showPokedexEntryText,
      pokedexEntryIdsToShow,
      progressNumber,
      imageUri,
      currentPokemonId,
      spawnablePokemon,
      catchableProgressNumber,
      starterListPokemon,
      filter,
      onlyShowMissingEntries,
      filterByCaught,
      filteredCaughtAmount,
      showLegendaries,
      showStarters,
      showSpawnable,
      claimShinyCharmModalisOpen,
      claimShinyCharm,
      youReceivedShinyCharmModal,
      totalPkm,
      catchablePkm,
      resetDexModalIsOpen,
      resetDex,
      shinyCharmClaimed,
      showAltDex,
      toggleAltDex,
      shinyCharmAmount,
      legendaryListPokemon
    };
  },
};
</script>

<style lang="scss" scoped>
.pokemon-list {
  &__entry {
    padding: 10px;
    margin-bottom: 20px;
  }
}

.pokemon-entry-button {
  padding-top: 68px;
  cursor: pointer;

  &__sprite {
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
    height: 68px;
    width: 68px;
    transition: all 100ms ease;
  }

  &:hover {
    height: 76px;
    width: 76px;
    top: -4px;
  }
}

.base-stats {
  display: flex;
  border-bottom: 1px solid rgba(155, 155, 155, 0.2);
  padding: 2px;

  &-name {
    width: 31%;
  }

  &-number {
    width: 10%;
  }

  &-bar {
    border-radius: 25px;
    height: 15px;
    margin-top: auto;
    margin-bottom: auto;
    box-shadow: black 0 0 0 2px;
  }
}

.pokeinfo-header {
  border-bottom: 1px solid #dee2e6;
  padding: 36px 16px 16px;

  &__sprite {
    position: absolute;
    width: 100%;
    left: 0;
    height: 150px;
    background-repeat: no-repeat;
    background-position: center;
    top: 30px;
    image-rendering: pixelated;
  }

  &__id {
    position: absolute;
    top: 25px;
    transform: rotate(-10deg);
    left: 25px;
    color: #c5c5c5;
  }

  &__name {
    margin-top: 8px;
  }

  &__type {
    position: absolute;
    width: 35px;
    right: 20px;
    top: 144px;

    & > div {
      height: 35px;
      border-radius: 100px;
      margin-bottom: 5px;
    }

    div > div {
      height: 100%;
      width: 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 65%;
      content: "";
    }

    &--ice {
      background: #76d1c1;
      box-shadow: #76d1c1 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/ice.svg");
      }
    }

    &--dark {
      background: #212121;
      box-shadow: #212121 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/dark.svg");
      }
    }

    &--fairy {
      background: #ef90e6;
      box-shadow: #ef90e6 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/fairy.svg");
      }
    }

    &--dragon {
      background: #0c6ac8;
      box-shadow: #0c6ac8 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/dragon.svg");
      }
    }

    &--psychic {
      background: #fa8582;
      box-shadow: #fa8582 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/psychic.svg");
      }
    }

    &--electric {
      background: #f2d94e;
      box-shadow: #f2d94e 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/electric.svg");
      }
    }

    &--grass {
      background: #60bd58;
      box-shadow: #60bd58 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/grass.svg");
      }
    }

    &--water {
      background: #539ddf;
      box-shadow: #539ddf 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/water.svg");
      }
    }

    &--fire {
      background: #fba64c;
      box-shadow: #fba64c 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/fire.svg");
      }
    }

    &--steel {
      background: #5795a3;
      box-shadow: #5795a3 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/steel.svg");
      }
    }

    &--ghost {
      background: #5f6dbc;
      box-shadow: #5f6dbc 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/ghost.svg");
      }
    }

    &--bug {
      background: #92bd2d;
      box-shadow: #92bd2d 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/bug.svg");
      }
    }

    &--rock {
      background: #c9bc8a;
      box-shadow: #c9bc8a 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/rock.svg");
      }
    }

    &--ground {
      background: #da7c4d;
      box-shadow: #da7c4d 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/ground.svg");
      }
    }

    &--poison {
      background: #b763cf;
      box-shadow: #b763cf 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/poison.svg");
      }
    }

    &--flying {
      background: #a1bbec;
      box-shadow: #a1bbec 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/flying.svg");
      }
    }

    &--fighting {
      background: #d3425f;
      box-shadow: #d3425f 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/fighting.svg");
      }
    }

    &--normal {
      background: #a0a29f;
      box-shadow: #a0a29f 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/normal.svg");
      }
    }
  }
}

.toggle-missing-button {
  width: 100%;
  margin: auto;
  border-radius: 15px;
  background-color: #dc8e18;
  border-color: black;
  color: white;

  &:disabled {
    opacity: 0.25;
  }

  &:enabled:hover {
    transform: scale(1.1);
  }
}
</style>
